import { PLATE_EDGE, SCREW_AT, SCREW_R, pocketPath, type PocketFit } from './rackPlateGeometry.ts'

/**
 * **랙 판 한 장** — 모니터링 데크 판의 실물 랙(`DeckRackFigure`)과 준비 › 랩웨어 그림
 * (`LabwarePreview`)이 **같이 쓰는** 판이다(eric 2026-09-27 「준비의 랩웨어 쪽에 그림들 수정해 줄래?」).
 *
 * 사진에서 옮긴 판(`DeckRackFigure` 머리말):
 *    - 바깥 판은 **모서리가 직각인 직사각형**(모따기 없음)
 *    - 한 단 낮은 **포켓**이 판 안에 파여 있고, 모따기는 **포켓의 네 귀**다(팔각)
 *    - **나사 구멍 넷**은 판의 네 귀 — 포켓 모따기 바깥의 삼각 살에 선다
 *    - **홈 둘**은 포켓 «긴 변» 가운데서 살 쪽으로 파인 반원
 *
 * 🔴 **판의 폭 · 높이만 받는다.** 세로(데크 · 긴 변이 위아래)냐 가로(랩웨어 정의 · 긴 변이 x)냐는
 *    부르는 쪽이 치수로 고른다 — 홈은 언제나 긴 변에 선다. CSS `rotate` 로 돌리지 않는다.
 * 🔴 살 폭 · 모따기 · 홈 · 나사 자리는 **판 크기와 무관한 고정 값**이다(데크 판 90×126 에서 잰 값).
 *    데크 판 값이 이 파일로 옮겨 왔을 뿐이라 데크 그림은 한 점도 바뀌지 않는다
 *    (`deckSupplies.test.tsx` 가 포켓 경로 원문을 잡는다).
 * 🔴 색 리터럴 없음 — 클래스만 달고 색은 `figures.css` 의 토큰이 정한다.
 */

const f = (v: number) => String(v)

/** 직각 바깥 판 + 팔각 포켓(긴 변 가운데 반원 홈) + 귀 나사 구멍 넷 */
export function RackPlate({
  width,
  height,
  pocket,
  screws: withScrews = true,
}: {
  width: number
  height: number
  /** 정의 구멍에 맞춰 물린 포켓(`pocketClearing`) — 없으면 사진 값 */
  pocket?: PocketFit | undefined
  /** 귀 나사 구멍 넷 — 팁 랙은 없다(eric 2026-10-19 사진 · 기본 있음) */
  screws?: boolean | undefined
}) {
  const screws: readonly (readonly [number, number])[] = [
    [SCREW_AT, SCREW_AT],
    [width - SCREW_AT, SCREW_AT],
    [SCREW_AT, height - SCREW_AT],
    [width - SCREW_AT, height - SCREW_AT],
  ]
  return (
    <>
      <rect
        className="fig-mod__plate"
        height={height - 2 * PLATE_EDGE}
        rx={1}
        width={width - 2 * PLATE_EDGE}
        x={PLATE_EDGE}
        y={PLATE_EDGE}
      />
      <path className="fig-mod__pocket" d={pocketPath(width, height, pocket)} />
      {(withScrews ? screws : []).map(([x, y]) => (
        <circle className="fig-mod__hollow" cx={x} cy={y} key={`s${f(x)}-${f(y)}`} r={SCREW_R} />
      ))}
    </>
  )
}
